import { Component } from '@angular/core';

@Component({
    selector: 'app-recurring-payments-page',
    templateUrl: './recurring-payments-page.component.html',
})
export class RecurringPaymentsPageComponent {}
